import { useIntl } from 'react-intl'
import { Dialog } from 'primereact/dialog'
import { LuxButton } from '@lux/wardrobe-lib'


const DialogPropagation = (props: {
    dialogVisible: boolean
    onSave: (propagate?: boolean) => void
    onHide: () => void
    status: string
}) => {
    const { dialogVisible, onSave, onHide, status } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-dialog-export-template'

    const renderFooter = () => {
        return (
            <div className={`${componentClass}__buttons`}>
                <LuxButton
                    onClick={onHide}
                    variant="outlined"
                    text={intl.formatMessage({
                        id: 'modals.dialog.buttons.cancel',
                        defaultMessage: 'Cancel',
                    })}
                />
                {!status.includes('remove') && <LuxButton
                    onClick={onSave}
                    text={intl.formatMessage({
                        id: 'modals.dialog.buttons.propagate',
                        defaultMessage: 'Apply to ALL',
                    })}
                />}
                {!status.includes('remove') && <LuxButton
                    onClick={() => {
                        onSave(false)
                    }}
                    text={intl.formatMessage({
                        id: 'modals.dialog.buttons.not.propagate',
                        defaultMessage: 'Apply to THIS ONLY',
                    })}
                />}
                {status.includes('remove') && <LuxButton
                    onClick={() => {
                        onSave(false)
                    }}
                    text={intl.formatMessage({
                        id: 'modals.filters.button.apply',
                        defaultMessage: 'Apply',
                    })}
                />}
            </div>
        )
    }

    return (
        <Dialog
            header={intl.formatMessage({
                id: 'modals.dialog.header.propagate',
                defaultMessage: 'Distribution list change',
            })}
            draggable={false}
            visible={dialogVisible}
            onHide={() => onHide()}
            footer={renderFooter()}
            style={{ width: '50vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            <div className={`${componentClass}__content`}>
                {
                    intl.formatMessage({
                        id: status ? status : '/',
                        defaultMessage:
                            "Do you want to apply the change to all the sub-folders in the modified folder as well?",
                    })
                }
            </div>
        </Dialog>
    )
}

export default DialogPropagation